import React from 'react'
import LoginComponent from "../../../Component/Auth/Login/index";
import InfoComponent from '../../../Component/Auth/Login/Info';
const Index = () => {

    return (
        <React.Fragment>
            <LoginComponent
            />
            <InfoComponent
            />
        </React.Fragment>
    )
}

export default Index